/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Sheet_ExpandInputs */

const en_ui_sheet_expand = /** @type {(inputs: Ui_Sheet_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expand panel`)
};

const de_ui_sheet_expand = /** @type {(inputs: Ui_Sheet_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereich aufziehen`)
};

/**
* | output |
* | --- |
* | "Expand panel" |
*
* @param {Ui_Sheet_ExpandInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_sheet_expand = /** @type {((inputs?: Ui_Sheet_ExpandInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Sheet_ExpandInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_sheet_expand(inputs)
	return de_ui_sheet_expand(inputs)
});